import Model from './Model'

const ShowUnavailable = true;
const SortOptions = {
	Match: 'Best Match',
	Availability: 'Availability',
	KeySkills: 'Key Skills (high to low)',
	Experience: 'Total Experience (high to low)',
	IndustryExperience: 'Industry Experience (high to low)',
	Rate: 'Bill Rate (low to high)',
	Location: 'Location (near to far)',
	Name: 'Talent Name (A-Z)',
};

export default class UserDiscipline extends Model
{
    static Key = 'UserDiscipline';

    static Cached = []
	static SortOptions = SortOptions;

    static normalize(props)
    {
        return props;
    }

    /*
    |--------------------------------------------------------------------------
    | Static Methods
    |--------------------------------------------------------------------------
    */

    static defaultSortingOptionFor(project)
    {
        return this.SortOptions.KeySkills;
    }

    static sortingOptionsFor(project)
    {
        let options = {...this.SortOptions};
        // if (!project.hasSchedule()) {
        //     delete options.Availability;
        // }

        return TB.values(options);
    }

    static matchSortingOptions()
    {
        let options = {
            best_match: "Best Match (high to low)",
            min_bill_rate: 'Bill Rate (low to high)',
            max_bill_rate: 'Bill Rate (high to low)',
            experience: 'Total Experience (high to low)',
            key_skills: 'Key Skills (high to low)',
            industries: 'Industry Experience (high to low)',
            first_name: 'Talent Name (A-Z)',
        };
        if (TB.auth()?.user?.().clientOrg?.()?.location){
            options.proximity = 'Location (near to far)'
        }
        return options
    }

    // TODO Keep
    static skillsForDisciplines(disciplineIds = []) {

        if (!disciplineIds.length) return undefined;

        let disciplines = TB.flatten(TB.map([...laravel.discipline_categories], 'disciplines'));


        disciplines = TB.filter(disciplines, discipline => disciplineIds.includes(discipline.id));

        let skills = TB.flatten(TB.map(disciplines, 'skills'));

        return TB.map(skills, skill => TB.pick(skill, [
            'name',
            'id',
            'value',
            'category'
        ]))
    }


    // TODO Keep
    static storedDiscipline(discipline_id, forClient = true) {

        if (!discipline_id || !laravel.discipline_categories) return null;

        let disciplines = TB.flatten(TB.map([...laravel.discipline_categories], 'disciplines'));

        // TODO Change with updated discipline filters for client/talent
        // let filterProp = forClient ? 'is_contractable' : 'is_applicable';
        //
        // disciplines = TB.filter(disciplines, [filterProp, true]);

        return TB.find(disciplines, ['id', discipline_id]);
    }

    // TODO Keep
    static rateForDiscipline(discipline_id, hourlyMarkUp = 0, forClient) {

        if (TB.isNaN(hourlyMarkUp) || !discipline_id || !laravel.discipline_categories) return null;

        let platformDiscipline = this.storedDiscipline(discipline_id, forClient)

        if (!platformDiscipline) return 100;

        let rate = Math.ceil(parseFloat(platformDiscipline.hourly_rate));
        return Math.ceil(rate * (1 + hourlyMarkUp));
    }

    static rateForDisciplineByExp(discipline_id, hourlyMarkUp = 0, forClient, experience ) {

        if (TB.isNaN(hourlyMarkUp) || !discipline_id || !laravel.discipline_categories) return null;

        let platformDiscipline = this.storedDiscipline(discipline_id, forClient)

        if (!platformDiscipline || !platformDiscipline.user_disciplines?.length) {
            return 100;
        }
        let rate = platformDiscipline.hourly_rate;
        if (experience) {
            let exp_score = laravel.talent_experience_levels[experience] || TB.keys(laravel.talent_experience_levels)[1];
            let exp_rate = TB.find(platformDiscipline.user_disciplines, ['self_score', exp_score]);
            if (exp_rate?.avg_hourly_rate) {
                rate = exp_rate.avg_hourly_rate
            }
        }

        rate = Math.ceil(parseFloat(rate));
        return Math.ceil(rate * (1 + hourlyMarkUp));
    }


    isEngagementLead()
    {
        return this.discipline.name === laravel.reserved_disciplines.engagement_lead;
    }


    static clearCache()
    {
    	this.Cached = undefined;
    }
}